// 2_components/header_search.js
// Mobile search magnifier in the header: toggles the search input active
// state (with outside-click / Luigi's Box close handling), toggles the Luigi
// hero block, and smooth-scrolls to a URL hash anchor on load.

export function init() {
	const body = document.body;

	/*-------------------------------------------------- SEARCH MAGNIFIER ON MOBILE*/
	const searchElement = document.querySelector("#header .search");
	const searchInput = document.querySelector("#header .search .search-input");

	if (searchInput) {
		searchElement.addEventListener("click", (e) => {
			if (e.target !== searchInput) {
				searchInput.classList.toggle("active");
				if (searchInput.classList.contains("active")) {
					body.classList.add("custom-search-active");
					searchInput.focus();
					setTimeout(() => {
						function outsideClickHandler(f) {
							const luigiAc = document.querySelector(".luigi-ac");
							const luigiAcClose = document.querySelector(".luigi-ac-close");
							const luigiShowAll = document.querySelector(".luigi-ac-button-block--show-all .luigi-ac-button");
							if (f.target == luigiAcClose || f.target == luigiShowAll) {
								searchInput.classList.remove("active");
								document.removeEventListener("click", outsideClickHandler);
								body.classList.remove("custom-search-active");
							}
							if (f.target !== searchInput && (!luigiAc || !luigiAc.contains(f.target))) {
								searchInput.classList.remove("active");
								document.removeEventListener("click", outsideClickHandler);
								body.classList.remove("custom-search-active");
							}
						}
						document.addEventListener("click", outsideClickHandler);
						// NOTE: this anonymous luigiSearchDone listener is added again on
						// every activation and is never removed (same as the old code).
						document.addEventListener("luigiSearchDone", function () {
							searchInput.classList.remove("active");
							body.classList.remove("custom-search-active");
							document.removeEventListener("click", outsideClickHandler);
						});
					}, 200);
				}
			}
		});
	}

	const luigiHero = document.querySelector(".luigi-ac-hero");
	if (searchElement && searchInput) {
		searchElement.addEventListener("click", function () {
			if (luigiHero) {
				luigiHero.classList.toggle("active");
			}
		});
	}

	/* custom scroll to anchor */
	document.addEventListener("DOMContentLoaded", function () {
		// Check if there's an anchor in the URL
		if (window.location.hash) {
			const anchor = window.location.hash.replace(/^[#\/]+|\/+$/g, "");
			const target = document.getElementById(anchor);
			if (target) {
				// Scroll to the element with a small offset (e.g., 80px)
				const offset = 80;
				const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
				window.scrollTo({
					top: elementPosition - offset,
					behavior: "smooth",
				});
			}
		}
	});
}
